import axios from "./axios";
import simpleAxios from "axios";

export async function searchCoin(payload) {
  try {
    const { data } = await axios.get("token/search", {
      params: payload,
    });

    return data.result;
  } catch (error) {
    return false;
  }
}

export async function searchLPToken(payload) {
  try {
    const { data } = await axios.get("token/search-lp-tokens", {
      params: payload,
    });

    return data.result;
  } catch (error) {
    return false;
  }
}

export async function getPools(payload) {
  try {
    const { data } = await axios.get("pools/index", {
      params: payload,
    });

    return data.result;
  } catch (error) {
    return false;
  }
}

export async function refreshPoolLP(payload) {
  try {
    await axios.get("pools/refresh-lp", {
      params: {
        chainId: payload,
      },
    });

    return true;
  } catch (error) {
    return false;
  }
}

export async function refreshPoolStake(payload) {
  try {
    await axios.get("pools/refresh-stake", {
      params: {
        chainId: payload,
      },
    });

    return true;
  } catch (error) {
    return false;
  }
}

export async function getMyNfts(payload) {
  try {
    const options = {
      method: "GET",
      url: `https://deep-index.moralis.io/api/v2/${payload.account}/nft`,
      params: {
        chain: `0x${Number(payload.chainID).toString(16)}`,
        format: "decimal",
        normalizeMetadata: "false",
      },
      headers: {
        accept: "application/json",
        "X-API-Key":
          "2KKrRXYc60UThWdSPzu9VGLvEsTsVJhyCmeXH76lYvcd8Q6XsWE2ad0DI7jTQZNr",
      },
    };

    const { data } = await simpleAxios.request(options);

    let results = data.result.flatMap((item) => {
      if (item.metadata)
        return { ...item, metadata: JSON.parse(item.metadata) };
      return item;
    });

    return results;
  } catch (error) {
    return false;
  }
}

export async function getMyNft(payload) {
  try {
    const options = {
      method: "GET",
      url: `https://deep-index.moralis.io/api/v2/nft/${payload.contract}/${payload.id}`,
      params: {
        chain: `0x${Number(payload.chainID).toString(16)}`,
        format: "decimal",
        normalizeMetadata: "false",
      },
      headers: {
        accept: "application/json",
        "X-API-Key":
          "2KKrRXYc60UThWdSPzu9VGLvEsTsVJhyCmeXH76lYvcd8Q6XsWE2ad0DI7jTQZNr",
      },
    };

    const { data } = await simpleAxios.request(options);

    let results = { ...data, metadata: JSON.parse(data.metadata) };

    return results;
  } catch (error) {
    return false;
  }
}

export async function getNftByURI(payload) {
  try {
    const { data } = await simpleAxios.get(payload);

    return data;
  } catch (error) {
    return false;
  }
}
